import HttpClientToken from '../../services/HttpClientToken';

import { ClaseDocumentoProps, defaultClaseDocumento } from '../../interfaces/catalogos/ClaseDocumentoInterface';

export const ClaseDocumento = () => {

    return new Promise<ClaseDocumentoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ClaseDocumento/', token)
            .then( ({ data } : { data : ClaseDocumentoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerClaseDocumento = () => {

    return new Promise<ClaseDocumentoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ClaseDocumento/ObtenerClaseDocumento', token)
            .then( ({ data } : { data : ClaseDocumentoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarClaseDocumento = ( params: ClaseDocumentoProps ) => {

    return new Promise<ClaseDocumentoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ClaseDocumento/Actualizar', params, token)
            .then( ({ data } : { data : ClaseDocumentoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultClaseDocumento } );
            });

        }

    });

}

export const AgregarClaseDocumento = ( params: ClaseDocumentoProps ) => {

    return new Promise<ClaseDocumentoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ClaseDocumento/Agregar', params, token)
            .then( ({ data } : { data : ClaseDocumentoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultClaseDocumento } );
            });

        }

    });

}
